<template>
  <div>
    <MemberLayout>
      <div class="contaienr">
        <div class="row">
          <div class="col-md-12">
            <div>
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                indicators
                background="transparent"
                img-width="1024"
                img-height="480"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <!-- Slides with img slot -->
                <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
                <b-carousel-slide
                  v-for="activity in activities"
                  :key="activity.id"
                >
                  <template v-slot:img>
                    <div class="row justify-content-center">
                      <div class="col-sm-6">
                        <b-card
                          :title="activity.title"
                          :img-src="activity.image"
                          img-alt="Image"
                          img-top
                          tag="article"
                          class="mb-2"
                        >
                          <router-link
                            class="btn btn-primary btn-block"
                            :to="`/member/news/activity-list/${activity.id}`"
                            >檢視詳情</router-link
                          >
                        </b-card>
                      </div>
                    </div>

                    <!-- <img
                      class="d-block img-fluid w-100"
                      width="1024"
                      height="480"
                      src="https://picsum.photos/1024/480/?image=55"
                      alt="image slot"
                    />-->
                  </template>
                </b-carousel-slide>
              </b-carousel>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import db from "../../api/db";
import MemberLayout from "../../components/member/MemberLayout";
export default {
  name: "ActivityListScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      activities: [],
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
  mounted() {
    const vm = this;
    db.collection("activities")
      .where("isPublished", "==", true)
      .orderBy("createdAt", "desc")
      .get()
      .then((docs) => {
        const activities = [];
        docs.forEach((doc) => {
          const activity = doc.data();
          activity.id = doc.id;
          activities.push(activity);
        });
        vm.activities = activities;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>